// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { AxiosError } from 'axios';
import { ofType } from 'redux-observable';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ActionType, getType } from 'typesafe-actions';

import { getOnlineCourseNotes } from '../../../apis/onlineCourse';
import { parseCamelCase } from '../../../apis/util';
import { RootAction, actionCreatorsList } from '../../rootActionCreator';
const { getOnlineCourseNotesDataActions } = actionCreatorsList;

const outputActions = {
  success: getOnlineCourseNotesDataActions.success,
  failure: getOnlineCourseNotesDataActions.failure
};

type RequestActionTypes = ActionType<
  typeof getOnlineCourseNotesDataActions.request
>;
type OutputActionTypes = ActionType<typeof outputActions>;

const getOnlineCourseContentsDataEpic = (
  action$: Observable<RootAction>
): Observable<OutputActionTypes> => {
  return action$.pipe(
    ofType(
      // action filter
      getType(getOnlineCourseNotesDataActions.request)
    ),
    switchMap((action: RequestActionTypes) => {
      // prepare api params
      const { id } = action.payload;
      // send api promise
      return getOnlineCourseNotes(id)
        .then(response => {
          const notes = response.data.message.notes;
          const parsedNotes = parseCamelCase(notes).map((note:any) => ({
            ...note,
            message: note.note,
            note: undefined
          }));
          // handle success case here
          return getOnlineCourseNotesDataActions.success({
            id,
            notes: parsedNotes
          });
        })
        .catch((error: AxiosError) => {
          // handle error case here
          console.log(error)
          return getOnlineCourseNotesDataActions.failure({ error });
        });
    })
  );
};

export { getOnlineCourseContentsDataEpic as default};
